import { render } from "./AllFooter.vue?vue&type=template&id=37bf5b0e&scoped=true"
import script from "./AllFooter.vue?vue&type=script&lang=js"
export * from "./AllFooter.vue?vue&type=script&lang=js"

import "./AllFooter.vue?vue&type=style&index=0&id=37bf5b0e&lang=less&scoped=true"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf5b0e"]])

export default __exports__